"use strict";
import { __exports as r } from "./index.es384.js";
import { __require as c } from "./index.es294.js";
import { __require as l } from "./index.es385.js";
var n;
function h() {
  return n ? r : (n = 1, (function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "isLocalURL", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    const i = c(), s = l();
    function u(o) {
      if (!(0, i.isAbsoluteUrl)(o)) return !0;
      try {
        const e = (0, i.getLocationOrigin)(), a = new URL(o, e);
        return a.origin === e && (0, s.hasBasePath)(a.pathname);
      } catch {
        return !1;
      }
    }
  })(r), r);
}
export {
  h as __require
};
//# sourceMappingURL=index.es292.js.map
